// extracted by mini-css-extract-plugin
export default {"card":"s9JR_djY","cardTitle":"LSII0ilx","editBtn":"GzxLmZ0p","rows":"cW1Gv5oH","row":"eH3VToEf","label":"sqEtFaUA","value":"ttTbEc7Z"};